import actions from "@/store/modules/var/actions";
import mutations from "@/store/modules/var/mutations";
import state from "@/store/modules/var/state";

export default {
    actions,
    mutations,
    state
}